/**
 * Apps Page
 *
 * Lists accessible applications and workspaces for context switching.
 * Uses ContextSwitcherPage from @bloomcode/shared-modules.
 */

import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@bloomcode/ui';
import { ContextSwitcherPage } from '@bloomcode/shared-modules';

export default function AppsPage() {
  return (
    <>
      <Helmet>
        <title>My Apps - Bloomcode Account</title>
      </Helmet>
      <div className="container mx-auto px-4 py-8">
        <Breadcrumb className="mb-4">
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/">Home</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage>My Apps</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        <ContextSwitcherPage
          title="My Apps"
          description="Switch between your accessible applications and workspaces"
          className="max-w-none p-0"
        />
      </div>
    </>
  );
}
